import React from 'react';

import Dialog from 'material-ui/Dialog';
import './alert.css';

const DeleteConfirm = ({ closeDialog, isDialogOpen }) => (
  <Dialog
    actions={
      <div className="buttons-div">
        <button type="button" className="alert-button" onClick={closeDialog}>
          CLOSE
        </button>
      </div>
    }
    open={isDialogOpen}
    paperProps={{ style: { borderRadius: '4px' } }}>
    <p style={{ textAlign: 'center' }}>You've successfully cancelled your shift.</p>
  </Dialog>
);

export default DeleteConfirm;



// WEBPACK FOOTER //
// ./src/components/Alert/DeleteSuccess.js